<template>
  <div class="page-frame project-list" v-if="pageData" role="main">
    <div class="container">
      <div v-if="pageData.acf && pageData.acf['header_image']" class="header-image" role="banner">
        <v-img
          v-bind:src="pageData.acf['header_image'].url"
          v-bind:alt="pageData.acf['header_image'].alt"
          aspect-ratio="3"
        ></v-img>
      </div>
      <h1
        class="page-title"
        v-if="pageData.acf && pageData.acf['display_page_title']"
        role="banner"
      >{{pageData.title.rendered}}</h1>
      <div v-html="pageData.content.rendered"></div>

      <section role="menubar" class="project-filters">
        <ul>
        <!-- <li
            class="project-filter"
            v-bind:class="{selected: !selectedCategory}"
            v-on:click="changeCategory(null)"
          >
            <button
              role="menuitemradio"
              v-bind:aria-label="$t('PROJECT_CATEGORY_FILTER')+' - ' + $t('ALL_CATEGORIES')"
            >{{ $t("ALL_CATEGORIES") }}</button>
          </li>-->
          <li
            class="project-filter"
            v-for="(category, index) in projectCategories"
            v-bind:key="index"
            v-bind:class="{selected: category.categoryId === selectedCategory}"
            v-on:click="changeCategory(category.categoryId)"
          >
            <button
              v-bind:aria-label="$t('PROJECT_CATEGORY_FILTER')+' - ' + category.categoryName"
            >{{category.categoryName}}</button>
          </li>
        </ul>
      </section>

      <section class="projects-list">
        <ul role="grid">
          <li
            v-for="(project, index) in projects"
            v-bind:key="index"
            class="project"
            role="row"

          >
            <router-link role="link" :to="getProjectLink(project)" class="project-link">
              <v-card role="gridcell" v-bind:elevation="1" :dark="contrastMode" class="project-card">
                <v-img
                  v-if="project.featuredImage"
                  v-bind:src="project.featuredImage"
                  v-bind:alt="project.featuredImageAlt"
                  aspect-ratio="2.5"
                ></v-img>
                <v-card-title primary-title>
                  <h3 class="project-name">{{project.name}}</h3>
                </v-card-title>
                <v-card-title>
                  <span>{{getProjectCategoriesNames(project.categoryIds).join(', ')}}</span>
                </v-card-title>
              </v-card>
            </router-link>
          </li>
        </ul>
      </section>

      <div class="load-more-project-wrapper" v-if="totalPages > currentPage">
        <v-btn :ripple="false" v-on:click="loadMoreProjects()">{{ $t("LOAD_MORE_PROJECTS") }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { getProjectViewName } from "../helpers/GetProjectViewName";
import { SUPPORTED_LANGUAGES } from "../i18n/i18n";

export default {
  name: "ProjectsList",
  props: {
    pageData: Object,
    contrastMode: Boolean
  },
  data: () => {
    return {
      projectCategories: [],
      projects: [],
      currentPage: 1,
      postsPerPage: 10,
      totalCount: null,
      totalPages: null,
      selectedCategory: null,
      masonry: null
    };
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      const params = {};
      if (this.$route.params.lang !== SUPPORTED_LANGUAGES[0]) {
        params.lang = this.$route.params.lang;
      }
      this.$spinner.show(this, this.contrastMode);
      this.$http
        .get("/wp/v2/project_categories?per_page=100", { params })
        .then(response => {
          this.projectCategories = response.data.map(category => {
            return {
              categoryId: category.id,
              categoryName: category.name
            };
          });
          this.$spinner.hide();
          const currentYearCategory = this.projectCategories.sort((a, b) => Number(b.categoryName) - Number(a.categoryName))[0];
          if (currentYearCategory) {
            this.changeCategory(currentYearCategory.categoryId);
          } else {
            this.getProjects();
          }
        });
    },
    getProjects(loadMore = false) {
      const params = {
        per_page: this.postsPerPage,
        page: this.currentPage
      };
      if (this.$route.params.lang !== SUPPORTED_LANGUAGES[0]) {
        params.lang = this.$route.params.lang;
      }
      if (this.selectedCategory) {
        params.project_categories = this.selectedCategory;
      }
      this.$spinner.show(this, this.contrastMode);
      this.$http.get("/wp/v2/project", { params }).then(response => {
        this.totalCount = Number(response.headers["x-wp-total"]);
        this.totalPages = Number(response.headers["x-wp-totalpages"]);
        const projects = response.data.map(project => {
          return {
            id: project.id,
            slug: project.slug,
            featuredImage: project.fimg_url,
            featuredImageAlt: project.fimg_alt,
            name: project.title.rendered,
            categoryIds: project.project_categories
          };
        });
        if (loadMore) {
          this.projects = [...this.projects, ...projects];
        } else {
          this.projects = projects;
        }
        // test muplitple projects
        // this.projects = [
        //   ...this.projects,
        //   ...this.projects,
        //   ...this.projects,
        //   ...this.projects,
        //   ...this.projects
        // ];
        setTimeout(() => {
          this.$redrawVueMasonry();
          this.$spinner.hide();
        }, 0);
      });
    },
    changeCategory(categoryId) {
      this.selectedCategory = categoryId;
      this.getProjects();
    },
    loadMoreProjects() {
      this.currentPage++;
      this.getProjects(true);
    },
    getProjectCategoriesNames(projectCategories) {
      return projectCategories.map(categoryId => {
        const categoryObject = this.projectCategories.find(
          cat => cat.categoryId === categoryId
        );
        return categoryObject ? categoryObject.categoryName : "";
      });
    },
    getProjectLink(project) {
      return {
        name: getProjectViewName(this.$i18n.locale),
        params: { locale: this.$route.params.locale, projectSlug: project.slug }
      };
    }
  }
};
</script>

<style lang="scss">
@import "../styles/_overrides.scss";
.project-list {
  ul {
    list-style-type: none;
    padding: 0;
    display: flex;
    flex-flow: row wrap;
    align-items: stretch;
    align-content: stretch;
  }

  .project-filters {
    margin: 3rem 0;
    ul {
      display: flex;
    }
    li {
      margin-right: 2rem;
      button {
        padding: 10px 0;
      }
    }
    .selected {
      border-bottom: 2px solid #000;
      font-weight: bold;
    }
  }

  .load-more-project-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 3rem 0;
  }

  .project {
    padding: 10px;
    width: percentage(1/3);
    margin-bottom: 10px;
    flex: 0 1 auto;
    @media (max-width: nth(nth($breakpoints, 3), 2)) {
      width: percentage(1/2);
    }
    @media (max-width: nth(nth($breakpoints, 1), 2)) {
      width: percentage(1/1);
    }
  }

  .project-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .v-responsive {
      flex: none;
    }
  }

  .project-link {
    text-decoration: none;
  }
}
</style>
